import { Slider, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { findMark } from '../utils';

type Props = {
  questionIndex: number;
  marks: any;
};

export const ChallengeTowerBar = ({ questionIndex, marks }: Props) => {
  const theme = useTheme();
  const xsBreakpoint = useMediaQuery(theme.breakpoints.only('xs'));

  const [value, setValue] = useState<number>(null);
  const [highlightLabel, setHighlightLabel] = useState<boolean>();

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
  };

  useEffect(() => {
    setHighlightLabel(true);
    setValue(value + 1);
  }, [questionIndex]);

  useEffect(() => {
    setValue(questionIndex + 1);
  }, []);

  const preventDrag = (e) => {
    e.preventDefault();
  };

  // const findMark = (val: number) => [...marks].reverse().find((mark) => val > mark.value);

  const getColorForValue = (val: number) => {
    const foundMark = findMark(val, marks);
    return foundMark ? foundMark.color : '#000'; // default color if no match
  };

  const getTextColorForValue = (val: number) => {
    const foundMark = findMark(val, marks);
    return foundMark ? foundMark.textColor : '#000'; // default color if no match
  };

  const valueLabelFormat = (value: number) => {
    const stage = findMark(questionIndex + 1, marks).stage;
    // return `Stage ${stage}: Q${value}`;
    return `Q${value}`;
  };

  return (
    <Slider
      getAriaLabel={() => 'Challenge'}
      orientation="vertical"
      defaultValue={value}
      value={value}
      valueLabelDisplay="on"
      valueLabelFormat={valueLabelFormat}
      marks={marks}
      step={1}
      sx={{
        color: getColorForValue(value),
        width: xsBreakpoint ? 9 : 18,
        padding: 0,
        borderRadius: 0,
        '& .MuiSlider-mark': {
          backgroundColor: '#bfbfbf',
          width: xsBreakpoint ? '16px' : '32px',
          '&.MuiSlider-markActive': {
            opacity: 1,
            backgroundColor: 'currentColor',
          },
        },
        '& .MuiSlider-thumb': {
          backgroundColor: 'transparent',
          '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
          },
          '&:before': {
            display: 'none',
          },
        },
        '& .MuiSlider-valueLabel': {
          lineHeight: 1.2,
          fontSize: 12,
          background: 'unset',
          padding: 0,
          width: xsBreakpoint ? 50 : 32,
          height: xsBreakpoint ? 24 : 32,
          borderRadius: '50% 50% 0% 50%',
          backgroundColor: getColorForValue(value),
          color: getTextColorForValue(value),
          fontWeight: 'bold',
          transformOrigin: 'bottom left',
          boxShadow: highlightLabel
            ? `0px 0px 9px 5px #aa4586, 0px 0px 5px 0px ${theme.palette.success.main}, 0px 0px 3px 0px ${theme.palette.success.main}`
            : 'none',
          transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
          '&:before': { display: 'none' },
          '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(32%, -32%) rotate(-45deg) scale(1)',
          },
          '& > *': {
            transform: 'rotate(45deg)',
          },
        },
        '& .MuiSlider-markLabel': {
          fontSize: xsBreakpoint ? '12px' : '14px',
        },
        '& .MuiSlider-markLabelActive': {
          textShadow:
            'rgb(255, 255, 255) 0px 0px 18px, rgb(255, 255, 255) 0px 0px 17px',
        },
      }}
      onChange={handleChange}
      onMouseDown={preventDrag}
      onTouchStart={preventDrag}
    />
  );
};
